import { LoadingController } from '@ionic/angular';
import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: 'loading.component.html'
})
export class LoadingComponent {

  constructor(private _loadCtrl: LoadingController) {}

  async wait() {
    const loading = await this._loadCtrl.create({
      spinner: 'crescent'
    });
    loading.present();
  }

  quit_wait() {
    this._loadCtrl.dismiss();
  }

}
